<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end
          ref="startEnd"
          timeModel="2,3,4,0"
          :datetime="true"
        ></start-end>
      </div>
      <div class="formTableItem">
        <p class="label">选择车辆</p>
        <selecAlotCCar
          ref="selecAlotCCar"
          @deviceIdList="searchItem.deviceIdList = $event"
        ></selecAlotCCar>
      </div>
      <div class="formTableItem">
        <p class="label">行驶里程(大于)</p>
        <InputNumber v-model="searchItem.mileage"></InputNumber>/km
      </div>
      <div class="formTableItem">
        <p class="label">行驶时长(大于)</p>
        <InputNumber v-model="searchItem.duration"></InputNumber>/分
      </div>
      <div class="formTableItem">
        <Button @click="exportAll" class="chaxun">导出</Button>
        <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center"
        },
        {
          title: "车牌号",
          key: "carNo"
        },
        {
          title: "设备号",
          key: "deviceNo"
        },
        {
          title: "单位名称",
          key: "groupName"
        },
        {
          title: "驾驶员",
          key: "driverName"
        },
        {
          title: "行驶里程",
          key: "mileage"
        },
        {
          title: "行驶时长/分",
          key: "duration"
        },
        {
          title: "开始日期",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime, "yymmdd"));
          }
        },
        {
          title: "结束日期",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime, "yymmdd"));
          }
        }
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
        duration: 0
      }
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.report + "/driving/sum",
        data: this.searchItem
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          this.tableData = data;
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList
        },
        {
          name: "driverIdList",
          value: this.searchItem.driverIdList
        },
        {
          name: "startTime",
          value: this.searchItem.startTime
        },
        {
          name: "endTime",
          value: this.searchItem.endTime
        }
      ];
      this.utils.exportData(this.axios.report + "/driving/export/sum", params);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    }
  },
  mounted() {
    this.chaxun();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// ../common/src/components/report/useCar.vue